import { render, staticRenderFns } from "./privilege.vue?vue&type=template&id=4334fe1b"
import script from "./privilege.vue?vue&type=script&lang=js"
export * from "./privilege.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports